import { render, staticRenderFns } from "./AccountPurchases.vue?vue&type=template&id=6f9e0811&"
import script from "./AccountPurchases.vue?vue&type=script&lang=js&"
export * from "./AccountPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports